import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmActionModalComponent } from '../../shared/components/confirm-action-modal';

/**
 * Confirmation modal component for deleting a location; presents the location and emits events for cancel or confirm actions.
 * @component
 * @selector app-delete-location-modal
 * @example
 *   <app-delete-location-modal [location]="sampleLocation" (close)="onModalClose()" (confirm)="onDeleteConfirmed($event)"></app-delete-location-modal>
 * @input {any} location - The location object to display and pass back when deletion is confirmed.
 * @output {void} close - Emitted when the modal is dismissed or the user cancels the deletion.
 * @output {any} confirm - Emitted with the location object when the user confirms deletion.
 * @method onClose() - Triggers the close event to notify the parent component to close the modal.
 * @method onConfirm() - Triggers the confirm event, emitting the current location to perform the deletion action.
 * @lifecycle No Angular lifecycle hooks are used in this component; it is a simple, event-driven presentational component.
 */
@Component({
  selector: 'app-delete-location-modal',
  standalone: true,
  imports: [ConfirmActionModalComponent],
  templateUrl: './delete-location-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./delete-location-modal.component.scss'],
})
export class DeleteLocationModalComponent {
  @Input() location: any;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<any>();

  onClose(): void {
    this.close.emit();
  }

  onConfirm(): void {
    this.confirm.emit(this.location);
  }
}
